import React from "react";
import { useNavigate } from "react-router-dom";
import { LanguageLocaleEnum, Player, TeamListElement } from "../../../client/api";
import { showTranslated, translate } from "../../../config/translator";
import { pathTeamView } from "../../../config/routes";
import BackButton from "../BackButton";
import PlayerImage from "../PlayerImage";
import RoundedRectangle from "../RoundedRectangle";

type PlayerHeaderProps = {
  player: Player | null;
  playerName: string;
  mainTeam: TeamListElement | null;
  loading: boolean;
  l: LanguageLocaleEnum;
};

const PlayerHeader: React.FC<PlayerHeaderProps> = ({
  player,
  playerName,
  mainTeam,
  loading,
  l
}) => {
  const navigate = useNavigate();

  return (
    <RoundedRectangle
      className="rounded-xl mb-4 bg-bg-secondary dark:bg-bg-secondary-dark border border-light-gray dark:border-light-gray-dark pt-20"
      hasBorder
      hasTitle={false}
    >
      <BackButton />
      {player ? (
        <div className="flex items-center gap-4 px-6 xl:px-8 pb-8">
          <PlayerImage
            image={player.photo}
            width={64}
            className="shrink-0 rounded-full"
            round
          />
          <div className="flex flex-col">
            <span className="text-base font-medium text-font dark:text-font-dark">
              {playerName}
            </span>
            {mainTeam ? (
              <button
                type="button"
                onClick={() => navigate(pathTeamView(mainTeam.id, "table"))}
                className="text-left"
              >
                <span className="text-sm font-normal text-font-600 dark:text-font-600-dark hover:text-primary dark:hover:text-primary transition-colors cursor-pointer">
                  {showTranslated(mainTeam.name, l)}
                </span>
              </button>
            ) : null}
          </div>
        </div>
      ) : (
        <span className="text-font-600 dark:text-font-600-dark px-6 xl:px-8 pb-8">
          {loading ? translate("loading", l) : translate("noMatch", l)}
        </span>
      )}
    </RoundedRectangle>
  );
};

export default PlayerHeader;

